import { render, staticRenderFns } from "./CommonSubdistrictSelector.vue?vue&type=template&id=0b652408&lang=pug&"
import script from "./CommonSubdistrictSelector.vue?vue&type=script&lang=ts&"
export * from "./CommonSubdistrictSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CommonSubdistrictSelector.vue?vue&type=style&index=0&id=0b652408&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports